import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private storage: Storage = window.localStorage;

  clear(): void {
    this.storage.clear();
  }

  getItem<T>(key: string): T {
    let item: T | string = this.storage.getItem(key);

    if (item != null) {
      try {
        item = JSON.parse(item);
      } catch (e) {
        // Couldn't parse, return as string
      }
    }

    // TODO check if as T is valid in this case
    return item as T;
  }

  removeItem(key: string): this {
    this.storage.removeItem(key);

    return this;
  }

  setItem<T>(key: string, item: T): this {
    this.storage.setItem(key, JSON.stringify(item));

    return this;
  }
}
